import script from "./NavbarA.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarA.vue?vue&type=script&setup=true&lang=js"

import "./NavbarA.vue?vue&type=style&index=0&id=5a6e1a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6e1a70"]])

export default __exports__